var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-card-area"},[(_vm.cardVisible)?[_c(_vm.componentName,{tag:"component",attrs:{"card-list":_vm.cardList,"miniEnv":_vm.miniEnv}})]:[_c('Markdown',{attrs:{"message":_vm.message}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }